<template>
    <div class="screen-page">
        <transition name="loading-screen">
            <loading-screen v-if="loading" />
        </transition>
        <template v-if="errors">
            <errors-zone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors">
            <div class="row">
                <update-screen-form
                    v-if="!screen.is_hidden"
                    v-for="screen in screens"
                    :key="screen.id"
                    :screen="screen"
                    :dashboards-components="dashboardsComponents" />
            </div>
            <template v-if="userRole === 'ADMIN'">
                <hr />
                <div class="mb-3">
                    <span class="h4">Écrans masqués</span>
                    (visibles uniquement aux admins)
                </div>
                <div class="row">
                    <update-screen-form
                        v-if="screen.is_hidden"
                        v-for="screen in screens"
                        :key="screen.id"
                        :screen="screen"
                        :dashboards-components="dashboardsComponents" />
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";
    import LoadingScreen from "../LoadingScreen";
    import {useGetLoader} from "../compositions/axios/loadingRequest";

    export default {
        name: "ScreenPage",

        components: {
            'errors-zone': ErrorsZone,
            'loading-screen': LoadingScreen,
        },

        props: {
            dashboardsComponents: {
                type: Object,
                required: true,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                loadedOnce: false,
                screens: null,
            }
        },

        created() {
            Echo.channel(`dashboards`).listen('ScreenUpdatedEvent', (e) => {
                this.loadStateFromServer();
            });
            Echo.channel(`dashboards`).listen('ScreenPingReportEvent', (e) => {
                this.loadStateFromServer();
            });
        },

        async mounted() {
            this.loadStateFromServer();
        },

        methods: {
            async loadStateFromServer() {
                const data = await this.load(`/espace-employes/ecrans/json`);
                if (data) {
                    this.screens = data;
                    this.loadedOnce = true;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .screen-page {
    }
</style>
